import { render, staticRenderFns } from "./YldsExaminewj.vue?vue&type=template&id=71b8a390&scoped=true"
import script from "./YldsExaminewj.vue?vue&type=script&lang=js"
export * from "./YldsExaminewj.vue?vue&type=script&lang=js"
import style0 from "./YldsExaminewj.vue?vue&type=style&index=0&id=71b8a390&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b8a390",
  null
  
)

export default component.exports